'use client';

import { Spinner } from '@heroui/react';
import { Icon } from '@iconify/react';
import useClientStore from '@/store/useClientStore';
import { useTranslation } from '@/i18n/hooks/useTranslation';
import BuilderPageWrapper from '@/components/builder2/BuilderPageWrapper';

// El form es pesado (calendario + RPCs); lo cargamos diferido para que la
// página pinte de inmediato.
import dynamic from 'next/dynamic';
const AgendarForm = dynamic(() => import('@/components/booking/AgendarForm'), {
  ssr: false,
});

export default function AgendarPage() {
  const { client, isLoading } = useClientStore();
  // Sin tenant no hay país: el idioma lo pone el provider (que el layout fija
  // por país en el servidor). En español los textos son los de siempre.
  const { t } = useTranslation();

  // Mientras el store hidrata el tenant, spinner.
  if (isLoading) {
    return (
      <div className="min-h-screen grid place-items-center bg-white dark:bg-dark-bg">
        <Spinner size="lg" />
      </div>
    );
  }

  // Host sin tenant resuelto: mensaje neutro, sin marca.
  if (!client) {
    return (
      <div className="min-h-screen grid place-items-center bg-white dark:bg-dark-bg px-6">
        <div className="text-center max-w-md">
          <Icon icon="mdi:calendar-remove-outline" className="text-5xl text-gray-400 mx-auto mb-4" />
          <h1 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            {t('booking.page.unavailableTitle')}
          </h1>
          <p className="text-gray-500 dark:text-gray-400">
            {t('booking.page.unavailableText')}
          </p>
        </div>
      </div>
    );
  }

  // La automotora puede maquetar esta página desde el builder, como Financiamiento
  // o Contacto. Mientras no la toque —y también si borró el bloque del formulario o
  // intentó ocultarla— se sirve el formulario de siempre: `/agendar` es un link que
  // reparten por WhatsApp e Instagram, así que no puede dejar de funcionar.
  return (
    <BuilderPageWrapper
      slug="agendar"
      requireComponent="AgendarFormEmbed"
      fallback={<AgendarForm client={client} />}
    />
  );
}
